export default "/public/dist/img/img_n5.jpg";